import React, { useContext } from "react";
import { variableContext } from "../../context/VariableContex";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewListIcon from "@mui/icons-material/ViewList";
import "./LayoutToggle.css";

const LayoutToggle = ({ size = "md", controlled = false, active = false, onToggle }) => {
  const { layoutMode, setLayoutMode } = useContext(variableContext);

  // Controlled mode: external component supplies `active` (true = left/grid state)
  // and `onToggle` handler. When controlled, do NOT touch global layout state.
  const isGrid = controlled ? !!active : layoutMode === "grid";

  const toggle = () => {
    if (controlled && typeof onToggle === "function") {
      onToggle();
      return;
    }
    setLayoutMode(isGrid ? "list" : "grid");
  };

  return (
    <div
      className={`lt-toggle lt-${size} ${isGrid ? "lt-grid" : "lt-list"}`}
      onClick={toggle}
      title={isGrid ? "Switch to List View" : "Switch to Grid View"}
    >
      <div className="lt-thumb">
        {isGrid
          ? <ViewModuleIcon className="lt-icon" />
          : <ViewListIcon className="lt-icon" />}
      </div>
    </div>
  );
};

export default LayoutToggle;
